module.exports = __webpack_public_path__ + "static/media/LogicLever1_2_4.7c95eb4f.png";